// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1mNiU","title":"card_title__G4Y_k","inActive":"card_inActive__3gSe9"};